import { sliderClose, sliderToggle } from "../common/sliderFunctions.js";

const sliders = document.querySelectorAll(".js-ns-dropdown-slider");

sliders.forEach(($slider) => {
    const items = $slider.querySelectorAll(".js-ns-dropdown-slider-item");

    items.forEach(($item) => {
        const $header = $item.querySelector(".js-ns-dropdown-slider-header");
        const $content = $item.querySelector(".js-ns-dropdown-slider-content");

        $header.addEventListener("click", (e) => {
            const expanded = e.currentTarget.getAttribute('aria-expanded') === 'true';

            items.forEach(($sibling) => {
                if ($item === $sibling) {
                    return;
                }
                const $header = $sibling.querySelector(".js-ns-dropdown-slider-header");
                $header.setAttribute('aria-expanded', "false");
                const $content = $sibling.querySelector(
                    ".js-ns-dropdown-slider-content"
                );

                $content.setAttribute('inert', "true");
                $sibling.classList.remove("opened");

                sliderClose($content, 500);
            });

            e.currentTarget.setAttribute('aria-expanded', !expanded);
            const $content = e.currentTarget.parentNode.querySelector(".js-ns-dropdown-slider-content");
            if(!expanded) {
                $content.removeAttribute('inert');
            }
            else {
                $content.setAttribute('inert', "true");
            }
            $item.classList.toggle("opened");

            sliderToggle($content, 500);
        });
    });
});
